export type SkillScope = 'System' | 'Project'

export interface Skill {
  id: string
  name: string
  displayName: string
  description: string | null
  scope: SkillScope
  projectId: string | null
  isSystem: boolean
  isReadOnly: boolean
  latestVersion: string | null
  latestVersionId: string | null
  attachmentCount: number
}

export interface SkillVersion {
  id: string
  skillId: string
  version: string
  contentSnapshot: string
  contentHash: string
  createdAt: string
  createdByName?: string | null
}

export interface SkillDetail {
  id: string
  name: string
  displayName: string
  description: string | null
  scope: SkillScope
  projectId: string | null
  isSystem: boolean
  isReadOnly: boolean
  content: string
  latestVersion: SkillVersion | null
}

export interface SkillAttachment {
  id: string
  skillId: string
  fileName: string
  contentType: string
  sizeBytes: number
  creationTime: string
}

export interface CreateSkillRequest {
  name: string
  displayName: string
  description?: string
  content: string
}

export interface UpdateSkillRequest {
  displayName: string
  description?: string
}

export interface CreateSkillVersionRequest {
  content: string
}

export interface CreateSkillResponse {
  skillId: string
  skillVersionId: string
  version: string
}

export type SkillCategory = 'System' | 'Custom'

export const SKILL_CATEGORIES: SkillCategory[] = ['System', 'Custom']

export function skillCategory(skill: Pick<Skill, 'isSystem'>): SkillCategory {
  return skill.isSystem ? 'System' : 'Custom'
}

